import { useState } from 'react';
function useForceRerender() {
    var _a = useState(null), setDummy = _a[1];
    return function () { return setDummy({}); };
}
export default useForceRerender;
